import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

interface PaymentMethod {
    Code: string;
    Name: string;
    Note: string;
    IsPopular: boolean;
}

interface AcceptedPayments {
    Methods: PaymentMethod[];
}

/// What the checkout takes, from Payment/GetAcceptedPayments: card when Stripe offers it to this viewer, and nothing
/// until then - the footer never advertises a way to pay the checkout does not offer. Cash on delivery, bKash and
/// Nagad join the list when they exist.
@Component({
    selector: 'app-footer-payments',
    templateUrl: './payments.component.html',
    styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit, OnDestroy {

    private destroy$: Subject<void> = new Subject();

    methods: PaymentMethod[] = [];

    /// Card is on the list for this viewer (live keys, or a sandbox test): the strip and the fine print say so.
    get hasCard(): boolean {
        return this.methods.some(m => m && m.Code === 'card');
    }

    open = false;

    constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: any) { }

    ngOnInit(): void {
        // Browser only: fetching this on the server held every page's render open for a call that only decorates the
        // footer. Until it answers the strip is not there at all.
        if (!isPlatformBrowser(this.platformId)) { return; }

        this.http.get<AcceptedPayments>(environment.apiUrl + '/api/Payment/GetAcceptedPayments')
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                res => {
                    if (res && res.Methods && res.Methods.length > 0) {
                        this.methods = res.Methods;
                    }
                },
                () => { /* no strip; a footer must not show an error */ }
            );
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    toggle(event?: Event): void {
        if (event) { event.preventDefault(); }
        this.open = !this.open;
    }

    close(): void {
        this.open = false;
    }
}
